import { Box, Button, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import { MainContainer, MainHeading } from '../../style/GlobalStyles';
import { useEffect, useRef, useState } from 'react';
import { get, post } from '../../api';
import { useAuth } from '../../hooks/useAuth';
import ServiceCard from '../../components/ServiceCard';
import NoDataPresentUI from '../../components/NoDataPresentUI';
import BlankIcon from '../../icons/BlankIcon';
import { useNavigate } from 'react-router-dom';

function PrimeAssessmentList() {
    const [allSurveys, setAllSurveys] = useState([]);
    const [loading, setLoading] = useState(false);
    const { getUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();

    useEffect(() => {
        handleGetSurvey();
    }, []);

    const handleGetSurvey = () => {
        if (userDetails?.contact?.id) {
            setLoading(true);
            post(`custom/getAssignedSurveys`, { contactId: userDetails?.contact?.id }).then((result) => {
                if (result.isSuccess) {
                    const data = result.data;
                    const sortedDataList = data?.sort(
                        (a, b) => new Date(b.assignmentLastModifiedDate) - new Date(a.assignmentLastModifiedDate)
                    );
                    setAllSurveys(sortedDataList);
                    setLoading(false);
                    console.log('getAssignedSurveys result.isSuccess: ', result);
                } else {
                    console.log('getAssignedSurveys result Error: ', result);
                    setLoading(false);
                }
            });
        }
    };

    const handleClick = (id) => {
        navigate(`/prime-assessment?surveyId=${id}&contactId=${userDetails?.contact?.id}`);
    };

    return (
        <MainContainer>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'}
                flexDirection={{
                    md: 'row',
                    xs: 'column',
                }}
            >
                <MainHeading sx={{ width: '100%' }}>Prime Assessment</MainHeading>
            </Box>
            <Divider
                sx={(theme) => ({
                    margin: `${theme.typography.generic.xxxxxLarge} 0`,
                })}
            />

            {loading ? (
                <CircularProgress />
            ) : (
                <>
                    {(!allSurveys || allSurveys?.length === 0) && (
                        <NoDataPresentUI
                            variant={'outlined'}
                            containerSx={{
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '100%',
                                },
                                height: '20rem',
                            }}
                            heading={
                                <>
                                    <Typography variant="h5" fontWeight={600} gutterBottom>
                                        No assessment found
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" gutterBottom>
                                        No assessment assigned to you, please contact the Sales team.
                                    </Typography>
                                </>
                            }
                            icon={<BlankIcon />}
                        />
                    )}
                    {allSurveys?.length > 0 && (
                        <Grid
                            container
                            spacing={2}
                            sx={{
                                marginTop: '1rem',
                                marginBottom: '2rem',
                            }}
                        >
                            {allSurveys?.map((cService) => {
                                return (
                                    <Grid
                                        item
                                        key={cService.id}
                                        sx={(theme) => ({
                                            [theme.breakpoints.down('sm')]: {
                                                width: '100%',
                                            },

                                            '@media (max-width:799px)': {
                                                minWidth: '100%',
                                                maxWidth: '100%',
                                            },
                                        })}
                                    >
                                        <ServiceCard
                                            serviceData={{ id: cService.id, name: cService.name, description: cService.description, status: cService.status }}
                                            onClick={(id) => handleClick(id)}
                                            hideTooltip
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                </>
            )}
        </MainContainer>
    );
}

export default PrimeAssessmentList;
